/*
 * SPDX-FileCopyrightText: 2023 CERN.
 * SPDX-License-Identifier: MIT
 */

export { CommunityTypeLabel } from "./CommunityTypeLabel";
export { RestrictedLabel } from "./RestrictedLabel";
